import type { FeatureModule } from '../types';
import kingdomFeature from './kingdom';

export const gameFeatures: FeatureModule[] = [kingdomFeature];
